import React from 'react';
import '../CSS/App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Home';
import About   from './About.js';
import Standings   from './Standings.js';
import Squads from './Squads.js';
import Captains from './Captains.js';
import Faq from './Faq.js';
import Donate from './Donate.js';
import Schedule from './Schedule.js';
import Clothing from './Clothing.js';
import Roster from './Roster.js';

function App() {
  return (
    <Router>
    <div>

    {/* /* 
You AlwaysNeed to add link here to make sure its actually pointing at the correct file 
*/ }
      <Routes>
        { <Route path="/" element={<Home />} /> }
        <Route path="/about" element={<About />} />
        <Route path="/standings" element={<Standings />} />
        <Route path="/squads" element={<Squads />} />
        <Route path="/roster" element={<Roster />} />
        <Route path="/captains" element={<Captains />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/Donate" element={<Donate />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/clothing" element={<Clothing />} />

      </Routes>
    </div>
  </Router>
  );
}

export default App;
